// Utility functions for encoding/decoding paste data

export const encodeData = (data) => {
  try {
    const jsonString = JSON.stringify(data);
    const encoded = btoa(unescape(encodeURIComponent(jsonString)));
    return encoded;
  } catch (error) {
    console.error('Error encoding data:', error);
    return null;
  }
};

export const decodeData = (encoded) => {
  try {
    const jsonString = decodeURIComponent(escape(atob(encoded)));
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error decoding data:', error);
    return null;
  }
};

export const generateId = () => {
  return Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
};

export const isExpired = (expiresAt) => {
  if (!expiresAt) return false;
  return new Date() > new Date(expiresAt);
};

export const getExpirationDate = (duration) => {
  if (!duration) return null;
  
  const now = new Date();
  const durations = {
    '10min': 10 * 60 * 1000,
    '30min': 30 * 60 * 1000,
    '1hour': 60 * 60 * 1000,
    '1day': 24 * 60 * 60 * 1000,
    '1week': 7 * 24 * 60 * 60 * 1000,
  };
  
  return new Date(now.getTime() + durations[duration]).toISOString();
};

// Simple hash function for password (client-side only - not secure for production)
export const hashPassword = async (password) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const verifyPassword = async (input, hash) => {
  const inputHash = await hashPassword(input);
  return inputHash === hash;
};
